/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    currentWasteType: {}
}

export const getters = {}

export const mutations = {
    SET_WASTETYPES(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_WASTETYPE(state, objects) {
        state.currentWasteType = objects
    }
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async getWasteTypes({ commit }) {
        try {
            return await graphqlClient.query({
                query: gql`
                query{
                  wastetypes {
                    id
                    name
                    created_at
                    deleted_at
                    updated_at
                    attribute{
                      id
                      description
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                }
            `,
            }).then((response) => {
              // // console.log(response)
              commit('SET_WASTETYPES', response.data.wastetypes)
              return response.data.wastetypes
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async getWasteTypeById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query getWasteTypeById($stid: ID!) {
                    wastetypeById(id: $stid) {
                      id
                      name
                      created_at
                      deleted_at
                      updated_at
                      attribute{
                        id
                        description
                        created_at
                        deleted_at
                        updated_at
                      }
                    }
                  }
                `,
                variables:{ stid: id }
            })
            commit('SET_WASTETYPE', response.data.getWasteTypeById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async createWasteType({ commit, dispatch }, {name} = {}) {
        try {
            // let that = this
            await graphqlClient.mutate({
                mutation: gql`
                mutation CreateWasteType($name: String!)  {
                  createWasteType(wastetype:{name:$name}) {
                    id
                    name
                  }
                }
                `,
                variables: { name: name},
            })
            dispatch('getWasteTypes')
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    // async updateServiceType({ commit, dispatch }, {id, name, description, capacity, attribute_ids, serviceCode} = {}) {
    //     try {
    //         // let that = this
    //         await graphqlClient.mutate({
    //             mutation: gql`
    //             mutation UpdateServiceType($stid:Int! $name: String! $description: String! $capacity: Float $attribute_ids: [ID] $ServiceCode: String)  {
    //               updateServiceType(id: $stid serviceType:{name:$name description:$description capacity:$capacity attribute_ids:$attribute_ids service_code: $ServiceCode}) {
    //                 id
    //                 name
    //               }
    //             }
    //             `,
    //             variables: {stid:id, name: name, description: description, capacity: capacity, attribute_ids: attribute_ids, ServiceCode: serviceCode},
    //         })
    //         dispatch('getServiceTypes')
    //     } catch (ex) {
    //         console.error(ex)
    //         throw ex
    //     }
    // },
    async deleteWasteType({ commit }, {id} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation DeleteWasteType($stid:Int!)  {
                  deleteWasteType(id: $stid) {
                    id
                  }
                }
                `,
                variables: { stid: id},
            })
            commit('SET_SERVICE_TYPES', response.data.deleteWasteType)

        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
}
